/**
 * 편집기 커서가 걸친 **한정된 이름**(`스키마.테이블`)을 읽는다 — 단일 정의.
 *
 * F4(스키마 정보 보기)는 두 곳에서 들어온다: 편집기 단축키(`SQLEditor`)와 메뉴 › 실행(`App`).
 * 두 곳이 각자 커서 주변을 훑고 있었고 규칙이 서로 달라, 같은 키인데 결과가 갈렸다
 * (실측 2026-09-20 — 메뉴 경로의 정규식은 `/\\w/` 라 **어떤 글자에도 맞지 않아** 늘
 * "테이블 이름을 찾을 수 없습니다" 였다). 규칙은 여기 하나만 둔다.
 *
 * 핵심: `sh.sales` 의 `sh` 에 커서가 있든 `sales` 에 있든 **`sh.sales`** 를 준다.
 * 한 토막만 주면 `sales` 는 스키마를 모른 채 찾고 `sh` 는 테이블로 찾혀 둘 다 실패한다.
 *
 * 구문 트리를 쓰지 않는 이유: 점으로 이어진 이름의 노드 모양이 SQL 방언마다 달라, 트리에
 * 기대면 방언이 바뀔 때 조용히 한 토막만 잡는다. 줄 텍스트를 넓히는 편이 예측 가능하다.
 */

/** Oracle 식별자에 쓰이는 글자 + 따옴표 식별자 */
const isIdentChar = (ch) => ch !== undefined && /[\w$#"]/.test(ch);

/**
 * @param {object} view CodeMirror EditorView
 * @returns {string} 예: `sh.sales` · `sales` · 빈 문자열
 */
export function qualifiedNameAtCursor(view) {
    if (!view || !view.state) return '';
    const { state } = view;
    const { from, to } = state.selection.main;
    // 사람이 직접 고른 범위가 있으면 그것이 우선이다 — 넓히지 않는다.
    if (from !== to) return state.doc.sliceString(from, to).trim();

    const line = state.doc.lineAt(from);
    const text = line.text;
    let s = from - line.from;
    let e = s;
    // 점은 **양쪽이 식별자일 때만** 넘어간다 — `sales.` 처럼 끝에 놓인 점을 삼키면
    // 이름이 끝난 자리에서 엉뚱한 글자까지 붙는다.
    while (s > 0 && (isIdentChar(text[s - 1]) || (text[s - 1] === '.' && isIdentChar(text[s - 2])))) s--;
    while (e < text.length && (isIdentChar(text[e]) || (text[e] === '.' && isIdentChar(text[e + 1])))) e++;

    let word = text.slice(s, e).trim();
    if (word.startsWith('"') && word.endsWith('"')) word = word.slice(1, -1);
    return word;
}

export default qualifiedNameAtCursor;
